// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCAf0TzJ1oRqoBoGKU8Oi1IpIzFbiL__7c",
  authDomain: "businessdirectory-441ba.firebaseapp.com",
  projectId: "businessdirectory-441ba",
  storageBucket: "businessdirectory-441ba.appspot.com",
  messagingSenderId: "847098689598",
  appId: "1:847098689598:web:c0ea187114dc9eb40db96f",
  measurementId: "G-59F02FDLRX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig); // eslint-disable-line no-unused-vars

export const db = getFirestore();


